import { render, staticRenderFns } from "./profile-info-edit.vue?vue&type=template&id=2fc8f6da&"
import script from "./profile-info-edit.vue?vue&type=script&lang=js&"
export * from "./profile-info-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports